export default function WhyChooseUsSection() {
  const reasons = [
    {
      icon: 'ri-heart-line',
      title: 'Compassionate Approach',
      description: 'We treat every situation with dignity, respect, and understanding. No judgment, no pressure, just genuine help when you need it most.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Complete Discretion',
      description: 'Your privacy matters to us. We handle every transaction confidentially and work discreetly to protect your personal situation from public scrutiny.'
    },
    {
      icon: 'ri-hand-coin-line',
      title: 'Fair Cash Offers',
      description: 'We provide competitive cash offers based on the property\'s true value, not just its current condition. You get a fair deal without the hassle of traditional sales.'
    },
    {
      icon: 'ri-time-line',
      title: 'Fast Closings',
      description: 'We can close in as little as 7 days or work on your timeline. No waiting for buyer financing, inspections, or lengthy approval processes.'
    },
    {
      icon: 'ri-tools-line',
      title: 'Full-Service Cleanup',
      description: 'Our experienced team handles all cleanup, junk removal, and property clearing. You don\'t touch a single item unless you want to.'
    },
    {
      icon: 'ri-file-text-line',
      title: 'Simple Process',
      description: 'No complicated paperwork, no real estate agents, no commissions. We handle everything from start to finish, making the process as easy as possible.'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Why Choose <span className="text-teal-600">TREX RE LLC</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            We're not just buying your property - we're providing a solution to a challenging situation with care and professionalism.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {reasons.map((reason, index) => (
            <div key={index} className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-cyan-600 rounded-xl flex items-center justify-center mb-6">
                <i className={`${reason.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">{reason.title}</h3>
              <p className="text-gray-700 leading-relaxed">{reason.description}</p>
            </div>
          ))}
        </div>

        <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
          <div className="grid md:grid-cols-2">
            <div className="p-10 lg:p-12">
              <h3 className="text-3xl font-bold text-gray-900 mb-6">Our Commitment to You</h3>
              <p className="text-gray-700 mb-6 leading-relaxed">
                At TREX RE LLC, we understand that selling a hoarder house isn't just a real estate transaction - it's often an emotional journey. Whether you're dealing with the loss of a loved one, helping a family member, or facing your own challenges, we're here to make the process as stress-free as possible.
              </p>
              <p className="text-gray-700 mb-6 leading-relaxed">
                Our team has years of experience working with hoarder properties and understands the unique challenges they present. We've developed efficient systems for cleanup and removal, established relationships with professional cleaning services, and know how to handle even the most overwhelming situations.
              </p>
              <p className="text-gray-700 leading-relaxed">
                <strong className="text-gray-900">Most importantly,</strong> we treat every client with the respect and dignity they deserve. Your situation is unique, and we tailor our approach to meet your specific needs and timeline.
              </p>
            </div>
            <div className="relative h-full min-h-[400px]">
              <img 
                src="https://public.readdy.ai/ai/img_res/f48865e4ddae841e724b0de01b6203ae.jpg"
                alt="Professional team ready to help"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
